export default __webpack_public_path__ + "static/media/tutorial-pc_7.0be51ea6.svg";